import { render, staticRenderFns } from "./Lista_UtilizxBeneficiario_pdf.vue?vue&type=template&id=50c62061&scoped=true&"
import script from "./Lista_UtilizxBeneficiario_pdf.vue?vue&type=script&lang=js&"
export * from "./Lista_UtilizxBeneficiario_pdf.vue?vue&type=script&lang=js&"
import style0 from "./Lista_UtilizxBeneficiario_pdf.vue?vue&type=style&index=0&id=50c62061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c62061",
  null
  
)

export default component.exports